import ButtonLoader from '../Button'

type RegisterButtonProps = {
  handleSubmit: () => void
  disabled: boolean
}

const RegisterButton = ({ handleSubmit, disabled }: RegisterButtonProps) => {
  return (
    <ButtonLoader
      onClick={handleSubmit}
      disabled={disabled}
      className="hero__form-button button button--yellow"
    >
      <span data-i18n="hero.button">РЕГИСТРАЦИЯ</span>
    </ButtonLoader>
  )
}

export default RegisterButton
